import {CreateStepParams} from 'pipelines/network/PipelineDAO';

/** @package */
export const COPY_STEPS_CLIPBOARD_CONTENT_TYPE = 'benchling-pipeline-step-upserts' as const;

/**
 * Shape of JSON content copied to clipboard.
 * @package
 */
export interface CopyStepsClipboardContent {
  type: typeof COPY_STEPS_CLIPBOARD_CONTENT_TYPE;
  steps: Array<CreateStepParams>;
}

/**
 * Function for parsing clipboard content, which may be in several formats.
 *
 * These functions should not raise on unexpected content, since the content may match another format.
 *
 * @returns null if clipboard content isn't of the expected format, else an array of step upserts.
 * @package
 */
export type ParseClipboardContentFn = (
  pipelineId: string,
  text: string
) => Promise<Array<CreateStepParams> | null>;
